'use client';

import { RelatedVideo } from '@/app_components/Article/embeds/RelatedVideo';
import { VerticalVideoPlayer } from '@/app_components/common/VerticalVideoPlayer';
import type { BaseArticle } from '@/app_lib/types/Article';

export interface RelatedVideoWithVerticalPlayerProps {
  adTags: BaseArticle['adTags'];
  relatedVideoId: BaseArticle['relatedVideoId'];
  videos: Array<{
    id: string;
    videoUrl: string;
    thumbnailUrl?: string;
    title?: string;
    description?: string;
  }>;
}

/**
 * Client component: renders RelatedVideo + VerticalVideoPlayer.
 * Vertical player launches when RelatedVideo scrolls 50% into view (once).
 * Must be a client component because renderTrigger is a function (cannot be passed from server).
 */
// biome-ignore lint/style/useNamingConvention: React component
export function RelatedVideoWithVerticalPlayer({
  adTags,
  relatedVideoId,
  videos,
}: RelatedVideoWithVerticalPlayerProps) {
  return (
    <VerticalVideoPlayer
      renderTrigger={({ setTriggerRef }) => (
        <div ref={setTriggerRef}>
          <RelatedVideo
            adTags={adTags}
            relatedVideoId={relatedVideoId}
          />
        </div>
      )}
      scrollTriggerOnce
      videos={videos}
    />
  );
}
